import { debounce } from 'lodash-es'

import { MAX_USING_FEE, MIN_USING_FEE } from '@/entities/map'
import { Slider } from '@/shared/ui'

import { USING_FEE_VALUE_FORMAT } from './value-format'
import { Description, Title } from '../../common/layout'

type Props = {
  ref: (element: HTMLDivElement) => void
  value: number[]
  onValueChange: (value: number[]) => void
  className?: string
}

export const UsingFeeInDialogView = ({
  ref,
  value,
  onValueChange,
  className,
}: Props) => {
  return (
    <div className={className} ref={ref}>
      <div className="mb-1 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Title className="mb-0">가격</Title>
          <Description>1주 임대료 및 관리비</Description>
        </div>
      </div>
      <Slider.Root
        value={value}
        onValueChange={debounce(onValueChange, 500)}
        min={MIN_USING_FEE}
        max={MAX_USING_FEE}
        step={50000}
        minStepsBetweenThumbs={1}
        valueFormat={USING_FEE_VALUE_FORMAT}
      >
        <Slider.Track />
        <Slider.RangeInput />
      </Slider.Root>
    </div>
  )
}
